import isFunction from 'lodash/isFunction';
import queryString from 'query-string';

/**
 * Bind methods
 */
export function bind(object, methods = []) {
  (methods || Object.getOwnPropertyNames(object.constructor.prototype)).forEach((key) => {
    if (key !== 'constructor' && isFunction(object[key])) {
      object[key] = object[key].bind(object);
    }
  });
  return object;
}

const CONFIGURABLE_VARS = [
  'main-text-color',
  'main-secondary-color',
  'main-input-label-color',
  'main-background-color',
  'main-accent-color',
  'main-accent-color-2',
  'main-accent-text-color',
  'alternate-text-color',
  'alternate-background-color',
  'main-container-transform-x'
];
const THEMES = {
  blue: {
    '--main-text-color': '#ffffff',
    '--main-secondary-color': '#1890ff',
    '--main-input-label-color': '#ffffff',
    '--main-background-color': '#112530',
    '--main-accent-color': '#1890ff',
    '--main-accent-color-2': '#40a9ff',
    '--main-accent-text-color': '#ffffff',
    '--alternate-text-color': '#ffffff',
    '--alternate-background-color': '#112530'
  },
  green: {
    '--main-text-color': '#000000',
    '--main-secondary-color': '#52c41a',
    '--main-input-label-color': '#000000',
    '--main-background-color': '#F9EECE',
    '--main-accent-color': '#52c41a',
    '--main-accent-color-2': '#73d13d',
    '--main-accent-text-color': '#000000',
    '--alternate-text-color': '#000000',
    '--alternate-background-color': '#F9EECE'
  }
};

export function applyCustomStyles() {
  const themeName = getParamValue('theme');
  const theme = THEMES[themeName];
  if (theme) {
    Object.entries(theme).forEach(([key, value]) => {
      document.documentElement.style.setProperty(key, value);
    });
  } else {
    CONFIGURABLE_VARS.forEach(key => {
      const value = getParamValue(key);
      if (value) document.documentElement.style.setProperty(`--${key}`, value);
    });
  }
}

export function getParamValue(paramName, search = window.location.search) {
  const params = queryString.parse(search);
  return params[paramName] ?? null;
}

export function pushWithParamsFromProps(props, pathname, extraParams = {}) {
  const {history, location} = props;
  if (!history || !location) return;
  return pushWithParams(history, location, pathname, extraParams);
}

export function pushWithParams(history, location, pathname, extraParams = {}) {
  const searchParams = new URLSearchParams(location.search);
  Object.entries(extraParams).forEach(([key, value]) => {
    searchParams.set(key, value);
  });
  history.push({
    pathname,
    search: searchParams.toString(),
  });
}

export function defaultIfBlank(value, defaultValue = null) {
  if (value === null || value === undefined) return defaultValue;
  if (typeof value === 'string' && value.trim() === '') return defaultValue;
  return value;
}

export function parseBoolean(val, def = true) {
  return val === undefined ? def : String(val).toLowerCase() === 'true';
}
